import React from 'react';
import TechExplorerHome from '../../BasicComponents/TechExplorerHome';

const TenantTechExplorerHome = () => {
  return <TechExplorerHome mode="tenant" />;
};

export default TenantTechExplorerHome;
